import {createTheme} from "@mui/material";
import {csCZ} from "@mui/x-data-grid/locales";

const govTheme = createTheme({
    palette: {
        primary: {
            main: "#2362A2"
        },
        secondary: {
            main: "#A8A8A8"
        },
        success: {
            main: "#6FBD2C"
        },
        info: {
            main: "#007BFF"
        },
        warning: {
            main: "#F9C13C"
        },
        error: {
            main: "#C52A3A"
        },
    },
}, csCZ);

export default govTheme;